import { render, staticRenderFns } from "./showDetail.vue?vue&type=template&id=28b063a0&scoped=true"
import script from "./showDetail.vue?vue&type=script&lang=js"
export * from "./showDetail.vue?vue&type=script&lang=js"
import style0 from "./showDetail.vue?vue&type=style&index=0&id=28b063a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b063a0",
  null
  
)

export default component.exports